import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { VendorCustomerType } from '@econtractor/types';
import SpinnerBlock from 'components/others/SpinnerBlock';
import VendorCustomersTableBody from './VendorCustomersTableBody';

interface VendorCustomersTableProps {
    rows: VendorCustomerType[];
    showSpinner?: boolean;
    onEdit: (row: VendorCustomerType) => void;
    onDelete: (row: VendorCustomerType) => void;
}

const VendorCustomersTable = ({
    rows,
    showSpinner = false,
    onEdit,
    onDelete,
}: VendorCustomersTableProps) => {
    const { t } = useTranslation(['Vendors']);

    return (
        <div className="position-relative">
            <SpinnerBlock onlyBlur={true} show={showSpinner} />
            <div className="crm-table-wrap">
                <Table className="VendorCustomersTable table-hover mb-0">
                    <thead>
                        <tr className="bg-light">
                            <td className="head-name">{t('subjects.fields.fullName')}</td>
                            <td className="head-article">{t('subjects.fields.edrpouOrIpn')}</td>
                            <td className="head-status">{t('subjects.fields.personType')}</td>
                            <td className="head-action">{t('subjects.fields.action')}</td>
                        </tr>
                    </thead>
                    <VendorCustomersTableBody rows={rows} onEdit={onEdit} onDelete={onDelete} />
                </Table>
            </div>
        </div>
    );
};

export default VendorCustomersTable;
